import Control from 'ol/control/Control';

const BASE_CLASS_NAME = 'ms3-zoom-to-feature-if-geometry-button';

class ZoomToFeatureIfGeometryButton extends Control {
	constructor(feature, options) {
		options = options || {};
		options.fitOptions = options.fitOptions || {};

		const buttonElement = document.createElement('button');
		buttonElement.className = `${BASE_CLASS_NAME}__button`;
		buttonElement.innerHTML = `
		<svg version='1.1' xmlns='http://www.w3.org/2000/svg' width='16' viewBox='0 0 1000 1000' style='margin-left: -1px'>
			<path d='M10,570L990,10L430,990V570H10z' style='fill: #00a8b3'></path>
		</svg>
	`;

		const handleClick = () => {
			super
				.getMap()
				?.getView()
				.fit(feature.getGeometry(), options.fitOptions);
		};
		buttonElement.addEventListener('click', handleClick, false);
		buttonElement.addEventListener('touchstart', handleClick, false);

		const controlElement = document.createElement('div');

		const updateClasses = () => {
			const enabledModifier = feature.getGeometry()
				? 'enabled'
				: 'disabled';
			controlElement.className = `${BASE_CLASS_NAME} ${BASE_CLASS_NAME}--${enabledModifier} ol-unselectable ol-control`;
		};

		controlElement.appendChild(buttonElement);
		updateClasses();

		feature.on('change:geometry', updateClasses);

		super({
			element: controlElement,
			target: options.target,
		});
	}
}

export default ZoomToFeatureIfGeometryButton;
